import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareDataService } from 'src/app/shared/services/share-data.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-approving-action-dialog',
  templateUrl: './approving-action-dialog.component.html',
  styleUrls: ['./approving-action-dialog.component.scss'],
})
export class AoActionDialogComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  title: string = '';
  inputLabel: string = '';
  okBtnLabel: string = '';
  isRequired: boolean = false;
  commentControl = new FormControl('');
  disabled: boolean = false;

  buttonHandler: (args: any) => void = () => {};

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.title = this.data.title;
    this.inputLabel = this.data.inputLabel;
    this.okBtnLabel = this.data.okBtnLabel;
    this.isRequired = this.data.isRequired;
    this.commentControl = this.data.commentControl;
    this.buttonHandler = this.data.buttonHandler;

    this.disabled = false;
  }

  get characterCount(): number {
    return this.commentControl?.value?.length ?? 0;
  }

  onConfirm(event: any) {
    if(!this.disabled) {
      this.buttonHandler(event);
      this.disabled = true;
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
